import fetch ,{getBlob2}from '../utils/fetch';


export function getOpinionlist(params) {
  return fetch({
    method: 'POST',
    url: '/feedback/getOpinion/list',
    data:params
  })
}

export function getOpinionFeedbackEnumv1(params) {
  return fetch({
    method: 'POST',
    url: '/feedback/getOpinionFeedbackEnum/v1',
    data:params
  })
}

export function getHouseDatalist(params) {
    return fetch({
        method: 'POST',
        url: '/archives/getHouseWholeData',
        data:params
    })
}
